import React from 'react';
import { AppTopBarMenuButton } from './AppTopBar';

/**
 * Sticky menu toggle aligned with legacy `.dash-frame-group` top rows (SA/SME/admin pages).
 * Lets every DashboardShell page get the hamburger without duplicating markup per page.
 */
export function AppTopBarLead() {
  return (
    <div className="app-topbar-lead" aria-hidden={false}>
      <AppTopBarMenuButton />
    </div>
  );
}

export default AppTopBarLead;
